import React from 'react';

import { cn } from '../../../../lib/css/className/className';
import { AlertLineSlideProps } from '../../types';
import { HStack, VStack } from '../../../Stack';
import { Header } from '../../../Header';
import { Text } from '../../../Text';
import { getSizeSkin } from '../../../../lib/skin/getSizeSkin/getSizeSkin';

import './AlertLineSlideDesktop.css';

const cls = cn('AlertLineSlideDesktop');

type AlertLineSlideDesktopProps = Omit<AlertLineSlideProps, 'textAlign' | 'isTitleTruncated'>;

export const AlertLineSlideDesktop = function AlertLineSlideDesktop(props: AlertLineSlideDesktopProps) {
    const { title, caption, actionIcon, buttonGroup, titleAddonLeft } = props;

    const sizeSkinClass = getSizeSkin('s');
    const alignItems = caption ? 'flex-start' : 'center';

    return (
        <HStack className={cls('', [sizeSkinClass])} justifyContent="space-between" gap="current-geometry">
            <HStack className={cls('content')} gap="current-geometry" alignItems={alignItems}>
                {titleAddonLeft}
                <VStack gap="4" className={cls('text')}>
                    <Header level="h5" color={'current'}>
                        {title}
                    </Header>
                    {caption && (
                        <Text size="xs" color={'current'} role="supplementary">
                            {caption}
                        </Text>
                    )}
                </VStack>
            </HStack>
            {(buttonGroup || actionIcon) && (
                <HStack gap="current-geometry">
                    {buttonGroup}
                    {actionIcon && <div className={cls('action')}>{actionIcon}</div>}
                </HStack>
            )}
        </HStack>
    );
};
